export default __webpack_public_path__ + "static/layout-example-light-ca8c350dff871931b8177aaa1d8d832f.png";